export default __webpack_public_path__ + "static/media/production-howItWork-crop-top.903a18e9.png";